export function toUpperFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function validateEmail(email) {
  const emailRegularExpression = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return emailRegularExpression.test(email);
}

/**
 * Format the phone number.
 *
 * @param phoneNumber
 * @return {*}
 */
export function formatPhoneNumber(phoneNumber = null) {
  if (phoneNumber === null) {
    return '';
  }
  let pass = /[+][1]\d{10}/.test(phoneNumber);
  if (pass && phoneNumber.length === 12) {
    return phoneNumber.replace(/\+1(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  } else {
    return phoneNumber;
  }
}

export function buildTaskName(trade) {
  return trade;
}

export function getLastTokenFromUrl(url, defaultValue = null) {
  let result = defaultValue;
  if (url !== undefined && url !== null) {
    const tokens = url.split('/');
    if (tokens.length > 0) {
      result = tokens[tokens.length - 1];
    }
  }
  return result;
}

export function formatNumber(number) {
  return number && number < 10 ? `0${number}` : number;
}



// WEBPACK FOOTER //
// ./src/services/utils/text-util.js